import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  slotProps: {
    paper: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  },
};

const ShapeModal = ({ open, onClose, onUpdate, text: initialText, r: initialR }) => {
  const [text, setText] = useState('');
  const [r, setR] = useState(20);

  useEffect(() => {
    if (open) {
        setText(initialText || '');
        setR(initialR || 20);
    }
  }, [open, initialText, initialR]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Update shape</DialogTitle>
      <DialogContent>
        <form style={{display: 'flex', flexWrap: 'wrap'}} autoComplete="off">
          <FormControl style={{margin: 24, minWidth: 120}}>
            <TextField margin="dense" label="Text" type="text" value={text} onChange={(e) => setText(e.target.value)} />
          </FormControl>
          <FormControl style={{margin: 24, minWidth: 120}}>
            <InputLabel>Size</InputLabel>
            <Select MenuProps={MenuProps} value={r} onChange={(e) => setR(Number(e.target.value))} input={<Input/>}>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={12}>12</MenuItem>
              <MenuItem value={14}>14</MenuItem>
              <MenuItem value={16}>16</MenuItem>
              <MenuItem value={18}>18</MenuItem>
              <MenuItem value={20}>20</MenuItem>
            </Select>
          </FormControl>
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={() => onUpdate(text, r)} color="primary">Update</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShapeModal;